import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import FormikInputField from 'components/forms/fields/FormikInputField';
import Button from 'components/buttons/Button';
import axios from 'data/axios';
import toast from 'react-hot-toast';
import Link from 'next/link';

const initialValues = {
    password: '',
    passwordConfirmation: '',
    token: ''
};

const schema = Yup.object().shape({
    password: Yup.string().required('Vnesi geslo.').min(6, 'Geslo mora biti dolgo vsaj 6 znakov.'),
    password_confirmation: Yup.string().oneOf([Yup.ref('password'), null], 'Gesli se ne ujemata.'),
    token: Yup.string().required()
});

const ResetPasswordForm = ({ token, onSuccess }: { token: string; onSuccess: () => void }) => {
    const [formState, setFormState] = useState(initialValues);
    const [serverError, setServerError] = useState(false);

    useEffect(() => {
        setFormState({ ...formState, token });
    }, [token]);
    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            await axios.patch('/public/reset-password', values);
            onSuccess();
            setSubmitting(false);
        } catch (e) {
            setSubmitting(false);
            toast.error('Gesla ni bilo mogoče spremeniti.');
            setServerError(true);
        }
    };

    return (
        <Formik
            enableReinitialize
            initialValues={formState}
            validationSchema={schema}
            onSubmit={handleSubmit}
            validateOnBlur={true}
        >
            {({ isSubmitting, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                    <FormikInputField
                        name="password"
                        label="Novo geslo"
                        type={'password'}
                        placeholder="Vnesi željeno geslo"
                        autocomplete="new-password"
                    />
                    <div className="mt-4">
                        <FormikInputField
                            name="password_confirmation"
                            label="Potrdi novo geslo"
                            type={'password'}
                            placeholder="Ponovno vnesi željeno geslo"
                            autocomplete="new-password-confirmation"
                        />
                    </div>
                    <div className="flex flex-col mt-4">
                        <Button color={'secondary'} variant={'contained'} type={'submit'} disabled={isSubmitting}>
                            <span className="font-bold">Spremeni geslo</span>
                        </Button>
                    </div>
                    {serverError && (
                        <>
                            <p className="mt-2 text-danger">Gesla ni bilo mogoče spremeniti.</p>
                            <p className="mt-1">
                                Poskusite ponovno zahtevati povezavo za ponastavitev gesla tako, da sledite{' '}
                                <Link href="/pozabljeno-geslo" className="underline font-bold">
                                    tej povezavi
                                </Link>
                                .
                            </p>
                        </>
                    )}
                </form>
            )}
        </Formik>
    );
};

export default ResetPasswordForm;
